import { Card, CloseButton, Image } from 'react-bootstrap'
import espa from '../assets/espa.png'
import '../styles/footerStyles.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { XMarkIcon } from '@heroicons/react/24/solid'

const Footer = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <Card className="footerCard">
            <div className="infoContainer">
                <div>
                    <h4>{t('contactInformation')}</h4>
                    <div>
                        <p>+30 6983145847</p>
                        <p>Σμύρνης 18, 68150 Αλεξανδρούπολη</p>
                        <p>info@gemluxury.eu</p>
                    </div>
                </div>

                <div>
                    <h4>{t('usefullInformation')}</h4>
                    <p onClick={() => {
                        const dialog = document.getElementById('termsAndPrivacyDialog');
                        const iframe = document.getElementById('termsPrivacyIframe');
                        iframe.src = '/tos.html#terms';
                        dialog.showModal();
                        }}>
                        {t('termsOfUse')}
                        </p>

                        <p onClick={() => {
                        const dialog = document.getElementById('termsAndPrivacyDialog');
                        const iframe = document.getElementById('termsPrivacyIframe');
                        iframe.src = '/tos.html#gdpr';
                        dialog.showModal();
                        }}>
                        {t('privacyPolicy')}
                        </p>

                        <dialog id="termsAndPrivacyDialog" className="dialog">
                            <div className="dialog-content">
                                <iframe
                                    id="termsPrivacyIframe"
                                    src="/tos.html"
                                    title="Όροι Χρήσης"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        border: "none",
                                    }}
                                />
                                <XMarkIcon
                                    className="dialog-close-btn"
                                    onClick={() => {
                                        const dialog = document.getElementById('termsAndPrivacyDialog');
                                        dialog.close();
                                    }}
                                >
                                </XMarkIcon>
                            </div>
                        </dialog>
                </div>
            </div>
        </Card>
    )
}

export default Footer